module.exports = __webpack_public_path__ + "static/media/O-grey.c19a09c5.svg";